<template>
  <v-container>
    <v-btn
      flat
      class="no-background mb-4"
      data-cy="payment-cancel"
      prependIcon="mdi-keyboard-backspace"
      @click="router.push({ name: 'profile' })"
    >
      {{ $t("views.payment.cancel") }}
    </v-btn>
    <v-alert v-if="error" type="error" class="mb-4">{{ error }}</v-alert>
    <v-progress-linear v-if="loading" indeterminate />
    <div ref="checkoutContainer" data-cy="payment-checkout"></div>
  </v-container>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";
import axios from "axios";
import { getStripe } from "@/utils/stripe";

const route = useRoute();
const router = useRouter();
const { t } = useTranslation();

const checkoutElement = useTemplateRef("checkoutContainer");
const loading = ref(true);
const error = ref(null);

let checkout = null;
let unmounted = false;

async function fetchClientSecret() {
  const response = await axios.get(
    "/api/stripe/checkout-session/" + route.params.session_id
  );
  return response.data.client_secret;
}

onMounted(async () => {
  try {
    const stripe = await getStripe();
    const instance = await stripe.createEmbeddedCheckoutPage({
      fetchClientSecret
    });
    if (unmounted) {
      instance.destroy();
      return;
    }
    checkout = instance;
    checkout.mount(checkoutElement.value);
  } catch (err) {
    console.error(err);
    error.value = t("views.payment.loadError");
  } finally {
    loading.value = false;
  }
});

onBeforeUnmount(() => {
  unmounted = true;
  checkout?.destroy();
  checkout = null;
});
</script>
